/* unplugin-vue-components disabled */import script from "./TableList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableList.vue?vue&type=script&setup=true&lang=ts"

import "./TableList.vue?vue&type=style&index=0&id=21045096&scoped=true&lang=less"
import "./TableList.vue?vue&type=style&index=1&id=21045096&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21045096"]])

export default __exports__